module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well media-manager",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("Biblioteka plików")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.fetchData($event)
      }
    }
  }, [_vm._v("Odśwież")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })]), _vm._v(" "), (_vm.errors.file) ? _c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errors.file))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetching),
      expression: "fetching"
    }]
  }, [_vm._v("Ładowanie...")]), _vm._v(" "), (_vm.hasMedias) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.medias), function(media) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": media.filepath,
        "target": "_blank",
        "title": "Otwórz w nowym oknie"
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": media.filepath,
        "height": "50"
      }
    })])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(media.filename) + "\n        ")]), _vm._v(" "), _c('td', [(_vm.isSelected(media)) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "title": "Odznacz",
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.unSelect(media)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-check"
    })]) : _c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "title": "Wybierz",
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(media)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-unchecked"
    })]), _vm._v(" "), _c('question-button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Usuń z biblioteki",
        "type": "button",
        "question": "Czy na pewno usunąć plik z biblioteki?"
      },
      on: {
        "click": function($event) {
          _vm.remove(media)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash"
    })])], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.showEmptyMessage) ? _c('div', [_vm._v("\n    Brak plików\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Wybierz")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Anuluj")])]), _vm._v(" "), (_vm.large) ? _c('large-media', {
    attrs: {
      "media": _vm.large
    },
    on: {
      "close": _vm.closeLarge
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn btn-info btn-large"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-upload"
  }), _vm._v(" Dodaj plik\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Miniatura")]), _vm._v(" "), _c('th', [_vm._v("Nazwa")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-709e7818","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaManager.vue
// module id = 458
// module chunks = 1